import React, { Component, PropTypes } from 'react';
import CropDialog from '../../tc-ui/image-crop/image-crop-dialog';
import Connection from './company-connection';
import ViewLink from './view-link';
import { equals, path } from 'ramda';
import $ from 'jquery';

function getRandomColorClass() {
  const colors = [
    'is-red',
    'is-pink',
    'is-purple',
    'is-deep-purple',
    'is-indigo',
    'is-blue',
    'is-light-blue',
    'is-cyan',
    'is-teal',
    'is-green',
    'is-deep-orange',
  ];

  const assignRandomColorClass = () => {
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return `profile-image-letter${assignRandomColorClass()}`;
}

class Logo extends Component {

  constructor(props) {
    super(props);
    this.state = { colorClass: getRandomColorClass() };
  }

  getEditableBackground = () => {
    const { isEditable, profileToShow } = this.props;
    if (isEditable) {
      if (profileToShow.profileImageUrl) {
        return (
          <div className="l-profile-logo-background">
            <CropDialog
              confirmCroppedFn={this.profileImageSourceChanged}
              uploadStartFn={this._toggleLoader.bind(this, 'logo', true)}
              cropWidth={256}
              cropHeight={256}
              imageName="profile"
              dialogWidth="400px"
              round
            >
              Edit
            </CropDialog>
          </div>
        );
      }
      return (
        <div
          style={{
            width: '128px',
            height: '128px',
            top: '-64px',
            left: '16px',
            lineHeight: '128px',
            borderRadius: '50%',
            position: 'absolute',
            color: '#fff',
            backgroundColor: 'rgba(184,184,184,.8)',
            textAlign: 'center',
          }}
        >
          <CropDialog
            confirmCroppedFn={this.profileImageSourceChanged}
            uploadStartFn={this._toggleLoader.bind(this, 'logo', true)}
            cropWidth={128}
            cropHeight={128}
            imageName="profile"
            dialogWidth="400px"
            round
          >
            Add Profile Photo
          </CropDialog>
        </div>
      );
    }
  };

  getProfileLogoNode = () => {
    const { routeName, profileToShow, isEditable } = this.props;
    const profileNameField = routeName === 'profile' ? 'companyName' : `${routeName}Name`;
    const logo = (() => {
      if (!profileToShow.profileImageUrl && !isEditable) {
        const companyLetter = profileToShow[profileNameField].charAt(0).toUpperCase();
        return (
          <div
            className={this.state.colorClass}
            style={{ lineHeight: '128px', fontSize: '38px' }}
          >
            {companyLetter}
          </div>
         );
      }
      const imageStyle = {
        backgroundImage: `url("${profileToShow.profileImageUrl}")`,
      };
      if (this.state.logoIsLoading) {
        const bgImg = new Image(128, 128);
        bgImg.onload = () => { // image is loaded
          this._toggleLoader('logo', false);
          delete bgImg.prototype;
        }
        bgImg.src = profileToShow.profileImageUrl;
      }
      return <div id="profileViewImage" className="profileViewImage" style={imageStyle} />;
    })();

    const showLoaderClass = this.state.logoIsLoading ? ' image-loading-indicater' : '';
    let logoPhotoClass = `l-profile-logo${((!profileToShow.profileImageUrl && !isEditable) ? ' profile-image' : '')} ${showLoaderClass}`;
    if (isEditable || profileToShow.profileImageUrl) logoPhotoClass += ' l-profile-logo-grey-background';

    return (
      <div>
        <div style={{ overflow: 'hidden' }} className={logoPhotoClass}>
          {logo}
        </div>
        {this.getEditableBackground()}
      </div>
    );
  };

  profileImageSourceChanged = (profileImageUrl) => {
    const { _saveField } = this.props;
    _saveField({
      route: 'profile',
      updateField: 'profileImageUrl',
      updateBody: profileImageUrl,
    });
  };

  _toggleLoader = (field, isLoading) => {
    this.setState({
      [`${field}IsLoading`]: isLoading,
    });
  };

  resizeImageAfterLoading = (e) => {
    let margin;
    if (e.target.width > e.target.height) {
      $('#profileViewImage').css({ width: '100%', height: 'auto' });
      margin = (128 - e.target.height) / 2;
      $('#profileViewImage').css({ 'margin-top': margin, 'margin-bottom': margin });
    } else {
      $('#profileViewImage').css({ width: 'auto', height: '100%' });
      margin = (128 - e.target.width) / 2;
      $('#profileViewImage').css({ 'margin-left': margin, 'margin-right': margin });
    }
    this._toggleLoader('logo', false);
  };

  render() {
    const { profileToShow } = this.props;
    const isViewedByOwner = equals(
      path(['user', 'company', 'companyId'], this.props),
      path(['profileToShow', 'companyId'], this.props)
    );
    const connectionInfoNode = profileToShow.connectionInfo ? <Connection {...this.props} /> : undefined;
    const viewsInfoNode = profileToShow.profileViews && isViewedByOwner ? <ViewLink {...this.props} /> : undefined;
    return (
      <div className="l-profile-logo-container">
        {this.getProfileLogoNode()}
        {connectionInfoNode}
        {viewsInfoNode}
      </div>
    );
  }
}

Logo.propTypes = {
  routeName: PropTypes.string,
  profileToShow: PropTypes.object,
  isEditable: PropTypes.bool,
  _saveField: PropTypes.func,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/logo.jsx